import { uri } from '../utils/config';
import { HTTP } from './secure/http';

export const updateOrderOfServices = async (placeId, positions) => {
  if (!placeId || !positions) {
    console.log('NO PLACE ID');
    return;
  }

  await HTTP.post({
    path: `${uri.api}/place/${placeId}/services/order`,
    data: { positions },
  });
};